import styled from 'styled-components';

export const StyledCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const VehicleInfo = styled.div`
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #000;
    .pipe {
        margin: 0 6px;
        color: #cad5e2;
        font-size: 20px;
        font-weight: 300;
    }
`;

export const DealDetails = styled.div`
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
`;

export const Comment = styled.span`
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
    width: 100%;
    svg {
        flex-shrink: 0;
    }
    .two-line-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
    }
`;

export const LastUpdated = styled.span`
    font-size: 14px;
    color: #6d6d6d;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 0;
    svg {
        flex-shrink: 0;
    }
`;
